import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import svgSelectBlack from '@img/icons/select-black.svg';
import svgSelectWhite from '@img/icons/select-white.svg';
import styled from 'styled-components';
const Select = styled.select `
  ${transition('background-color, border-color, color')}

  display: block;
  appearance: none;
  background: var(--bgColor);
  background-position: center right 12px;
  background-repeat: no-repeat;
  border: 1px solid var(--borderColor);
  color: var(--fgColor);
  height: ${fluid(45, 56)};
  ${fonts.apercu.light}
  font-size: 18px;
  margin: 0;
  padding: 7px 12px;
  width: 100%;

  &:disabled {
    opacity: 0.5;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 5px;
  }

  &[data-theme='dark'] {
    --bgColor: ${brand.black};
    --borderColor: ${brand.white};
    --fgColor: ${brand.white};
    background-image: url('${svgSelectWhite}');
  }

  &[data-theme='light'] {
    --bgColor: ${brand.white};
    --borderColor: ${brand.greyMid};
    --fgColor: ${brand.greyMid};
    background-image: url('${svgSelectBlack}');
  }

  &[data-hidden='true'] {
    display: none;
  }
`;
const SelectStyles = {
    Select,
};
export default SelectStyles;
